/**
 * Step 10 (renumbered 2026-05-16, was step 12) — Profile data
 *
 * Spec: specs/onboarding-rebuild.md → Act 3 step 10
 *
 * Mason 2026-05-16 restructure: bundles the rhythm sliders (age, days/wk,
 * min/day) that used to live on old step 3 (reading-rhythm). All "tell us
 * about you" data lives here now — captured AFTER trust is built by the
 * AI demo + streak + ministry map seed.
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import ProfileDataSynthesis from './ProfileData.synthesis'

export const ROLE_OPTIONS = [
  { value: 'new_believer', label: 'New Believer' },
  { value: 'growing_christian', label: 'Growing Christian' },
  { value: 'small_group_leader', label: 'Small Group Leader' },
  { value: 'pastor_teacher', label: 'Pastor / Teacher' },
  { value: 'seminary_student', label: 'Seminary Student' },
  { value: 'other', label: 'Other' },
]

export const DENOMINATION_OPTIONS = [
  'Non-denominational',
  'Baptist',
  'Catholic',
  'Methodist',
  'Presbyterian',
  'Lutheran',
  'Pentecostal',
  'Anglican / Episcopal',
  'Other',
]

export const TRANSLATION_OPTIONS = ['KJV', 'NKJV', 'NASB', 'NLT', 'NIV', 'ESV', 'WEB', 'YLT']

// Mason's lock 2026-05-14: 9 chips — dropped "mental health & faith",
// added "Christian history" + "Parenting". Order matches Mason's pick.
export const INTERESTS_OPTIONS = [
  { value: 'theology', label: 'Theology' },
  { value: 'apologetics', label: 'Apologetics' },
  { value: 'prayer', label: 'Prayer' },
  { value: 'sermon_prep', label: 'Sermon prep' },
  { value: 'christian_living', label: 'Christian living' },
  { value: 'marriage_family', label: 'Marriage & family' },
  { value: 'evangelism', label: 'Evangelism' },
  { value: 'christian_history', label: 'Christian history' },
  { value: 'parenting', label: 'Parenting' },
]

export default function ProfileDataStep({
  role,
  denomination,
  preferredTranslation,
  personalizeToDenomination,
  interests,
  // Rhythm sliders — moved from old step 3 (Mason 2026-05-16).
  age,
  days,
  minutes,
  onChange,
  onContinue,
  firstName,
  displayName,
}) {
  return (
    <ProfileDataSynthesis
      role={role}
      denomination={denomination}
      preferredTranslation={preferredTranslation}
      personalizeToDenomination={personalizeToDenomination ?? true}
      interests={interests || []}
      age={age}
      days={days}
      minutes={minutes}
      onChange={onChange}
      onContinue={onContinue}
      roleOptions={ROLE_OPTIONS}
      denominationOptions={DENOMINATION_OPTIONS}
      translationOptions={TRANSLATION_OPTIONS}
      interestsOptions={INTERESTS_OPTIONS}
      firstName={firstName}
      displayName={displayName}
    />
  )
}
